module.exports = __webpack_public_path__ + "static/media/van.8b624061.svg";